const unitPrice = (data: any): number => {
  if (!data) return 0;
  const price =
    data.netAmount !== 0 && data.discountPrice !== 0
      ? data.discountPrice
      : data.amount;
  return Number(price) || 0;
};

export const flattenCartItems = (cartInfo: any[]): any[] => {
  if (!Array.isArray(cartInfo)) return [];
  return cartInfo.reduce((acc: any[], product: any) => {
    if (!(product?.references && product.references.length > 0)) {
      return acc.concat([product]);
    }
    return acc.concat(
      product.references.map((itemRef: any) => ({
        ...product,
        references: [
          {
            ...itemRef,
            data: product.productData?.references?.find(
              (field: any) => field.id === itemRef.id
            ),
          },
        ],
      }))
    );
  }, []);
};

const itemTotal = (item: any): number => {
  if (item?.references && item.references.length > 0) {
    const reference = item.references[0];
    return (Number(reference.quantity) || 0) * unitPrice(reference.data);
  }
  return (Number(item?.quantity) || 0) * unitPrice(item?.productData);
};

export const getCartSubtotal = (cartInfo: any[]): number =>
  flattenCartItems(cartInfo).reduce(
    (total: number, item: any) => total + itemTotal(item),
    0
  );

export const isDigitalProduct = (productData: any): boolean =>
  productData?.type === "digital" || productData?.typeProduct === "digital";

export const getPhysicalCartSubtotal = (cartInfo: any[]): number =>
  flattenCartItems(cartInfo).reduce(
    (total: number, item: any) =>
      isDigitalProduct(item?.productData) ? total : total + itemTotal(item),
    0
  );

export const hasOnlyDigitalProducts = (cartInfo: any[]): boolean =>
  Array.isArray(cartInfo) &&
  cartInfo.length > 0 &&
  cartInfo.every((item: any) => isDigitalProduct(item?.productData));

export const getProductUnitPrice = unitPrice;
